var base = require('settings/profile');

Vue.component('spark-profile', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/profile.js